const flashMessage = {
  sk: {
    fill_required_fields: "Pred pokračovaním vyplňte povinné polia",
    fill_payment_shipping: "Pred pokračovaním zvoľte spôsob dopravy a platby",
    fill_package_text:
      "Ak ste si zvolili text na balenie, vyplňte textové pole",
    fill_text_fields: "Prosím skontrolujte si a vyplňte všetky textové polia",
    success_send_contact: "Formulár bol úspešne odoslaný",
    unavailable_variant: "Variant produktu nie je dostupný.",
  },
  cs: {
    fill_required_fields: "Před pokračováním vyplňte povinná pole",
    fill_payment_shipping: "Před pokračováním zvolte způsob dopravy a platby",
    fill_package_text:
      "Pokud jste si zvolili text na balení, vyplňte textové pole",
    fill_text_fields: "Prosím zkontrolujte si a vyplňte všechna textová pole",
    success_send_contact: "Formulář byl úspěšně odeslán",
    unavailable_variant: "Varianta produktu není dostupná.",
  },
};

export default flashMessage;
